import type { VoucherInput } from "@/lib/gql/__generated__/graphql";

import type * as Shared from "../../../../../_shared";

type Props = {
	viewModel: Shared.Model.Type.FormModel["ViewModel"];
};

export const viewModelToInputConverter = ({ viewModel }: Props): VoucherInput => {
	const input: VoucherInput = {
		hotelID: viewModel.hotelID,
		voucherID: viewModel.voucherID,

		inSale: viewModel.inSale.value,

		name: viewModel.name.value,
		description: viewModel.description.value,

		mainKeyVisual: {
			bucket: viewModel.mainKeyVisual.bucket.value,
			key: viewModel.mainKeyVisual.key.value,
			region: viewModel.mainKeyVisual.region.value,
			mimeType: viewModel.mainKeyVisual.mimeType?.value,
			fileName: viewModel.mainKeyVisual.fileName?.value,
		},

		voucherPrice: {
			currencyType: viewModel.voucherPrice.currencyType.value,

			amount: viewModel.voucherPrice.amount?.value,
		},
		sellingPrice: {
			currencyType: viewModel.sellingPrice.currencyType.value,

			amount: viewModel.sellingPrice.amount?.value,
		},

		saleTypeForTerm: viewModel.saleTypeForTerm.value,
		saleStart: viewModel.saleStart?.value,
		saleEnd: viewModel.saleEnd?.value,

		voucherLimitType: viewModel.voucherLimitType.value,
		cinStart: viewModel.cinStart?.value,
		cinEnd: viewModel.cinEnd?.value,

		intervalPrepDates: viewModel.intervalPrepDates?.value,
		soldNumTotal: viewModel.soldNumTotal.value,
		maxStockNum: viewModel.maxStockNum?.value,
	} satisfies VoucherInput;

	return input;
};
